/* eslint-disable */
import { IFilterCriteriaModel } from '@fr/vue/types/backboneModels/BackboneFiltersCriteriaModel';
const LIMIT_HOTELS_VIEW = 10;
const LIMIT_HOTELS_VIEW_INITIAL = 10;
const LIMIT_HOTELS_VIEW_RESORT = 30;

const UNTRACEABLE_FILTERS_NAMES: Array<keyof IFilterCriteriaModel> = ['isPopularityFilterActive'];

export { LIMIT_HOTELS_VIEW, LIMIT_HOTELS_VIEW_INITIAL, LIMIT_HOTELS_VIEW_RESORT, UNTRACEABLE_FILTERS_NAMES };